import DownloadChartCard from './downloadChartCard.component';

export default DownloadChartCard;